import React from "react";
import { XS_MEASURE_LINE_COLOR } from "../constants";

const XS_SCALE_MIN = 0.6;
const XS_SCALE_MAX = 2;
const XS_SCALE_STEP = 0.2;

const CrossSectionViewer2D = ({
  xsViewerRef,
  xsPos,
  xsScale,
  setXsScale,
  changeXsScale,
  resetXsPos,
  onXsTitlePointerDown,
  crossSectionCanvasRef,
  crossSectionOutline,
}) => {
  return (
    <div
      ref={xsViewerRef}
      className={"stl-xs-viewer" + (xsPos ? " free" : "")}
      aria-label="2D cross section view"
      style={{
        "--xs-scale": xsScale,
        ...(xsPos
          ? { left: xsPos.fx * 100 + "%", top: xsPos.fy * 100 + "%" }
          : {}),
      }}
    >
      <div
        className="stl-xs-viewer-title"
        onPointerDown={onXsTitlePointerDown}
        onContextMenu={(e) => e.preventDefault()}
        onDoubleClick={resetXsPos}
        title="Right-drag to move · double-click to reset position"
      >
        <span className="stl-xs-viewer-title-text">
          2D Cross section
          <span style={{ color: XS_MEASURE_LINE_COLOR, marginLeft: 6, fontWeight: 700 }}>
            · Click 2 points to measure · Drag points to adjust · Wheel to zoom · Right-drag to pan
          </span>
        </span>
        <div className="stl-xs-size-ctrl">
          <button
            type="button"
            className="stl-xs-size-btn"
            onClick={() => changeXsScale(-XS_SCALE_STEP)}
            disabled={xsScale <= XS_SCALE_MIN}
            title="Make smaller"
            aria-label="Make 2D view smaller"
          >−</button>
          <button
            type="button"
            className="stl-xs-size-btn"
            onClick={() => setXsScale(1)}
            disabled={xsScale === 1}
            title="Default size"
            aria-label="Reset 2D view size"
          >⟲</button>
          <button
            type="button"
            className="stl-xs-size-btn"
            onClick={() => changeXsScale(XS_SCALE_STEP)}
            disabled={xsScale >= XS_SCALE_MAX}
            title="Make bigger"
            aria-label="Make 2D view bigger"
          >+</button>
        </div>
      </div>
      
      {/* Canvas needs a stable parent wrapper to prevent React removeChild errors */}
      <div className="stl-xs-canvas-wrapper" style={{ flex: 1, minHeight: 0, position: 'relative' }}>
        <canvas ref={crossSectionCanvasRef} className="stl-xs-canvas" />
        {!crossSectionOutline && (
          <div className="stl-xs-empty">
            No intersection at current offset
          </div>
        )}
      </div>
    </div>
  );
};

export default CrossSectionViewer2D;